import { createMongoAbility, subject as asSubject, type MongoAbility } from '@casl/ability';
import type { AbilityAction, AbilityRule, AbilitySubject, Role } from '@/api/types';

/**
 * The dashboard evaluates the exact CASL rules the API enforces: `/auth/me` returns them and we
 * build a MongoAbility from them. Hiding a button here is UX only — the server re-checks everything.
 */
type InstanceSubject =
  | ({ role: Role; id?: string } & { __caslSubjectType__: 'User' })
  | ({ id: string } & { __caslSubjectType__: 'Workspace' });

export type AppAbility = MongoAbility<[AbilityAction, AbilitySubject | InstanceSubject]>;
export type { AbilityAction, AbilitySubject };
/** A route / nav-item requirement, e.g. `['read', 'Ticket']`. */
export type AbilityCheck = [AbilityAction, AbilitySubject];

export function buildAbility(rules: AbilityRule[]): AppAbility {
  return createMongoAbility<AppAbility>(rules as never);
}

export const subject = asSubject;
